var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"column",staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"ui primary button",on:{"click":_vm.login}},[_vm._v(" Login ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }